/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Public_TitleInputs */

const cs_import_public_title = /** @type {(inputs: Import_Public_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import do organizace`)
};

const en_import_public_title = /** @type {(inputs: Import_Public_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization import`)
};

/**
* | output |
* | --- |
* | "Organization import" |
*
* @param {Import_Public_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_public_title = /** @type {((inputs?: Import_Public_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Public_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_public_title(inputs)
	return cs_import_public_title(inputs)
});